import * as tracking from 'dibs-tracking';

export function trackBreadcrumbClick(key, event = null) {
    tracking.trackEvent(
        {
            category: 'navigation',
            action: 'breadcrumb click',
            label: `pdp|${key}`,
        },
        event
    );
}
